import {
  PayeeRequirement,
  PayeeRequirementExpirationStatus
} from "@wingspanhq/wingspan-api-sdk";

export const selectorIsRequirementExpired = (requirement: PayeeRequirement) => {
  return (
    requirement.expirationStatus === PayeeRequirementExpirationStatus.EXPIRED
  );
};
